import React from "react";
import Logo from "@/components/Logo";

// Shared brand lockup so every page header reads identically instead of
// showing the page name (June 2026 request).
export default function BrandLockup() {
  return (
    <div className="flex items-center gap-2.5 min-w-0 shrink-0" data-testid="brand-lockup">
      <Logo className="h-9 w-9 sm:h-11 sm:w-11 shrink-0" />
      <div className="leading-tight min-w-0">
        <p className="font-display text-sm sm:text-xl uppercase tracking-tight text-white whitespace-nowrap">
          <span className="text-[#E2E30A]">Performance</span> Nutrition
        </p>
        <p className="hidden sm:block text-[10px] uppercase tracking-[0.28em] text-zinc-200 mt-1 whitespace-nowrap">Powered by SPC</p>
      </div>
    </div>
  );
}
